<template>
  <nav class="mt-5 flex-1 px-2 bg-white space-y-1">
    <router-link to="/media/latest"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md"
      active-class="bg-gray-100 text-gray-900">
      <i class="fas fa-list fa-fw mr-4 ml-1"></i>
      <span class="text-sm">Latest Media</span>
    </router-link>

    <router-link to="/media/search"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md"
      active-class="bg-gray-100 text-gray-900">
      <i class="fas fa-search fa-fw mr-4 ml-1"></i>
      <span class="pb-1 md:pb-0 text-sm">Search Media</span>
    </router-link>

    <!-- <router-link :to="{ name: 'MediaContentRequests' }"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md"
      active-class="bg-gray-100 text-gray-900">
      <i class="fas fa-lightbulb-exclamation-on fa-fw mr-4 ml-1"></i>
      <span class="pb-1 md:pb-0 text-sm">Content Requests</span>
    </router-link> -->

    <router-link to="/media/streams-wall"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md"
      active-class="bg-gray-100 text-gray-900">
      <i class="fas fa-signal-stream fa-fw mr-4 ml-1"></i>
      <span class="pb-1 md:pb-0 text-sm">Live Chaser Video</span>
    </router-link>

    <router-link to="/media/purchases"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md"
      active-class="bg-gray-100 text-gray-900">
      <i class="fas fa-shopping-basket fa-fw mr-4 ml-1"></i>
      <span class="pb-1 md:pb-0 text-sm">Purchased Content</span>
    </router-link>

    <router-link to="/media/members"
      class="text-gray-900 group flex items-center content-center px-2 py-3 text-sm font-medium rounded-md"
      active-class="bg-gray-100 text-gray-900">
      <i class="fas fa-users fa-fw mr-4 ml-1"></i>
      <span class="pb-1 md:pb-0 text-sm">Network Members</span>
    </router-link>
  </nav>
</template>

<script>
export default {
  name: "MediaNavigationPartial"
};
</script>
